import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import "./styles.css";
import { App } from "./App";
import { initStudio } from "./lib/studio";

initStudio();

// O resumo que o servidor injeta para os robôs mora dentro do #root: o React
// limpa o container no primeiro render, então o navegador pinta uma vez só.
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
